import { useState, useEffect, useLayoutEffect, useRef } from "react";
import {
  getInitialTheme,
  getEffectiveTheme,
  applyTheme,
} from "../utils/themeUtils";
import { ReactComponent as SystemSVG } from "../SVGcomponents/System.svg";

function getWindowDimensions() {
  const { innerWidth: width, innerHeight: height } = window;
  return {
    width,
    height,
  };
}

export function useWindowDimensions() {
  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions(),
  );

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return windowDimensions;
}

// import { useState, useLayoutEffect } from 'react';

export const useOnClickOutside = (ref: any, action: () => void) => {
  useEffect(() => {
    const handleClickOutside = (event: any) => {
      if (ref.current && !ref.current.contains(event.target)) {
        action();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [action, ref]);
};

export default useOnClickOutside;

export const useMount = ({ isOpened }: { isOpened: boolean }) => {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    if (isOpened && !mounted) {
      setMounted(true);
    } else if (!isOpened && mounted) {
      setTimeout(() => {
        setMounted(false);
      }, 300);
    }
  }, [isOpened]);

  return {
    mounted,
  };
};

export const useInitTheme = () => {
  useLayoutEffect(() => {
    const initialTheme = getInitialTheme();
    applyTheme(initialTheme);
  }, []);
};
